import { isDevelopment, isStaging } from '@Infowijs-eng/component-library/modules'

export default (slug) => {
  if (!slug || typeof slug !== 'string') {
    throw new Error('Please pass a community slug as string')
  }

  if (isDevelopment && process.env.INFOWIJS_CLIENT_SCHOOLWIKI) {
    return process.env.INFOWIJS_CLIENT_SCHOOLWIKI.toLowerCase().replace('[subdomain]', slug)
  }

  const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'
  const envUriPart = isStaging ? '.staging' : ''

  return `https://${slug}${envUriPart}.schoolwiki.${tld}/admin/`
}
